/** بازه‌های امتیاز عملکرد اپراتور (۰ تا ۱۰۰) و رنگ هر بازه؛ مشترک بین صفحه تماس، اپراتورها و گزارش‌ها */
export const SCORE_BANDS = {
  excellent: { label: 'عالی', range: '۹۰ تا ۱۰۰', from: '#10b981', to: '#34d399', text: 'text-emerald-600' },
  good: { label: 'خوب', range: '۷۵ تا ۸۹', from: '#65a30d', to: '#a3e635', text: 'text-lime-600' },
  acceptable: { label: 'قابل قبول', range: '۶۰ تا ۷۴', from: '#f59e0b', to: '#fbbf24', text: 'text-amber-600' },
  poor: { label: 'نیازمند توجه', range: 'زیر ۶۰', from: '#ef4444', to: '#f97316', text: 'text-red-600' },
};

export const bandOf = (score) => {
  if (score == null) return null;
  if (score >= 90) return 'excellent';
  if (score >= 75) return 'good';
  if (score >= 60) return 'acceptable';
  return 'poor';
};

export const bandMeta = (score) => {
  const key = bandOf(score);
  return key ? SCORE_BANDS[key] : null;
};

/** اختلاف با میانگین: کمتر از ۱ امتیاز را «هم‌سطح» حساب می‌کنیم */
export const describeDelta = (delta, reference) => {
  if (delta == null) return null;
  const abs = Math.abs(delta);
  if (abs < 1) return { tone: 'neutral', text: `هم‌سطح با ${reference}` };
  const n = abs.toLocaleString('fa-IR', { maximumFractionDigits: 1 });
  return delta > 0
    ? { tone: 'up', text: `${n} امتیاز بالاتر از ${reference}` }
    : { tone: 'down', text: `${n} امتیاز پایین‌تر از ${reference}` };
};
